// extracted by mini-css-extract-plugin
export default {"body":"tooltip_body__ReJfB","content":"tooltip_content__A44jx"};